<template>
    <div class="modal black" id="trader-info" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{filterData.id ? 'EDIT FILTER' : 'ADD FILTER'}}</h5>
             <div class="action">
            <!-- <a href="#" class="mx-3"><i class="fa fa-expand"></i></a> -->
            <a  @click="$emit('close')" aria-label="Close"><i class="fa fa-times"></i></a>
          </div>
         
           
          </div>
          <div class="modal-body">
              <div class="d-flex">
                 <span class="text-muted mb-3" style="font-size: 14px; color:#6c757d;">
                    <span style="color:red">*</span> Fields marked with an asterisk are required.
                  </span>
                </div>
            <form>
              <div class="form-row">
                    <div class="form-row">
                    <div class="form-group col-md-2 required">
                        <label for="inputEmail4">Filter Name
                         <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter a unique name to identify this filter.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="text" class="form-control" id="inputEmail4" placeholder="Filter Name"  v-model="filterData.name" >
                    </div>
                    <div class="form-group col-md-2 required">
                        <label for="inputEmail4">Product
                           <span class="hint" data-toggle="tooltip" data-placement="right"  title="Select the product type for which you want to apply this filter.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="filterData.offeringTypeId">
                            <option value="1">MUNICIPAL</option>
                            <!-- <option value="2">CORPORATE</option>                  `` -->
                        </select>
                    </div>
                     <div class="form-group col-md-2 required">
                        <label for="inputEmail4">Min Offering Price
                            <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the minimum offering price you are willing to consider.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min Offering Price"  v-model="filterData.minPrice" >
                    </div>
                     <div class="form-group col-md-2 required">
                        <label for="inputEmail4">Max Offering Price
                            <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the maximum offering price you are willing to consider.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Offering Price"  v-model="filterData.maxPrice" >
                    </div>
                      <div class="form-group col-md-2 required">
                        <label for="inputEmail4"> Min Maturity Year
                          
                            <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the earliest maturity year to include in the filter.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span> 
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder=" Min Maturity Year"  v-model="filterData.minYear" >
                    </div>
                    <div class="form-group col-md-2 required">
                        <label for="inputEmail4">Max Maturity Year
                        
                            <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the latest maturity year to include in the filter.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Maturity Year"  v-model="filterData.maxYear" >
                    </div>
                    <div class="form-group col-md-2 required">
                        <label for="inputEmail4">Min Coupon %
                            <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the minimum coupon percentage required.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="minCoupon"  v-model="filterData.minCoupon" >
                    </div>
                       <div class="form-group col-md-2 required">
                       <label for="inputEmail4">S&P Rating From 
                        
                        <span class="hint" data-toggle="tooltip" data-placement="right"  title="Select the minimum S&P rating to include.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                       </label>
                        <select @change="checkRatingRangeisValid()" class="form-control" id="exampleFormControlSelect"  v-model="ratingFrom">
                            <option value>Please select</option>
                            <option
                            v-for="spfrom in spRatingConstants"
                            :key="spfrom"
                            v-bind:value="spfrom"
                          >{{spfrom}}</option>
                          </select>
                    </div>
                    <div class="form-group col-md-2 required">
                        <label for="inputEmail4">S&P Rating To
                
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Select the maximum S&P rating to include.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <select @change="checkRatingRangeisValid()" class="form-control" id="exampleFormControlSelect1"  v-model="ratingTo">
                            <option value>Please select</option>
                            <option
                            v-for="sp in spRatingConstants"
                            :key="sp"
                            v-bind:value="sp"
                            
                          >{{sp}}</option>
                          </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputLast">Description
                         
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter a brief description explaining the purpose of this filter.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input type="text" class="form-control" id="inputLast" placeholder="description"  v-model="filterData.description" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min Qty (In thousands)
                         
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the minimum quantity (in thousands) you want to filter by.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min Quantity"  v-model="filterData.minQuantity" >
                    </div>
                   
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min YTW
                        
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the Minimum Yield to Worst (YTW) you are looking for.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min YTW"  v-model="filterData.minYtw" >
                    </div>
                  
                    

                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min Call Year
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the earliest call year to include.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min Call Year"  v-model="filterData.minCallYear" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Call Year
                          
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Enter the latest call year to include.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Call Year"  v-model="filterData.maxCallYear" >
                    </div>
                 
                    <div class="form-group col-md-2">
                         <label for="inputEmail4">Underlying Rating From  
                         
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Select the minimum underlying rating.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                         </label>
                          <select @change="checkRatingRangeisValidUnder()" class="form-control" id="exampleFormControlSelect"  v-model="ratingFromUnder">
                              <option value>Please select</option>
                              <option
                              v-for="spfrom in spRatingConstants"
                              :key="spfrom"
                              v-bind:value="spfrom"
                            >{{spfrom}}</option>
                            </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="inputEmail4">Underlying Rating To
                        <span class="hint" data-toggle="tooltip" data-placement="right"  title="Select the maximum underlying rating.">
                          <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                      </label>
                        <select @change="checkRatingRangeisValidUnder()" class="form-control" id="exampleFormControlSelect1"  v-model="ratingToUnder">
                            <option value>Please select</option>
                            <option
                            v-for="sp in spRatingConstants"
                            :key="sp"
                            v-bind:value="sp"
                            
                          >{{sp}}</option>
                          </select>
                    </div>  

                    <div class="form-group col-md-2 required" v-if="!isClient"> 
                        <label for="inputEmail4">User</label> 
                        <multiselect
                          v-model="selectedClient"
                          placeholder="Select"
                          :options="clientList"
                          :multiple="false"
                          label="clientFullName"
                          @input="onClientSelect"
                          track-by="id"
                        ></multiselect>
                        <!-- <select class="form-control client-select form-control-sm" v-model="filterData.userId" >
                          <option value="" disabled selected>Select Client </option>
                          <option v-for="client in clientList" :key="client.id" :value="client.id">
                            {{ client.clientFullName }}
                          </option>
                        </select> -->
                    </div>
                    </div>
                    <div class="form-row col-md-12 mt-3">
                      <div class="form-group col-md-6">
                      <div class="d-flex justify-content-between align-items-center"><label for="inputLast"><div>States</div> <div style="font-size: 12px; color: #6c757d"> * Click a state to select, selected States will be in blue color. </div></label> <a class="allStates" @click="selectAllState()"><i class="fa fa-angle-right"></i> {{isStateSelectAll ? 'Select' : 'Unselect'}} All</a></div>
                      <div class="flex-container">
                        <div v-for="state in stateCodes" :key="state.code" @click="selectState(state)" class="states" :class="{ statesAtive: state.isActive }">
                          {{ state.short }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6 attributes">
                        <label for="inputEmail4">Attributes
                         
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Use Include to only show these bonds , or Exclude to hide them.">
                            <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label><a class="allStates mb-3 mr-0" @click="clearAllAttributes()"><i class="fa fa-trash"></i> Clear All</a>
                        <table class="table align-items-center table-flush table-hover bidtbl black-tbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class="text-left"></th>
                              <th scope="col" class="text-center text-white">EXCLUDE</th>
                              <th scope="col" class="text-center text-white">INCLUDE</th>
                            </tr>
                          </thead>
                          <tbody class="list no-cursor attr-table">
                           
                            <tr>
                              <td>insured 
                               
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude insured bonds.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                          
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.insured" name="EXCLUDEinsured" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.insured" name="INCLUDEinsured" value="INCLUDE">
                                </div>
                              </td>
                           
                            </tr>
                          
                            <tr>
                              <td>taxable
                                 
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude taxable bonds.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.taxable" name="EXCLUDEtaxable" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.taxable" name="INCLUDEtaxable" value="INCLUDE">
                                </div>
                              </td>
                             
                            </tr>
                            <tr>
                              <td>Alternative Min Tax
                                
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude bonds subject to Alternative Min Tax.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                             
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.amt" name="EXCLUDEAMT" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.amt" name="INCLUDEAMT" value="INCLUDE">
                                </div>
                              </td>
                            
                            </tr>
                            
                            
                          </tbody>
                        </table>
                    </div>
                    </div>
                  <div class="form-row col-md-12">
                    <div class="form-group col-md-6">
                        <label for="inputLast">Cusip
                          
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Add CUSIP numbers to filter specific bonds. Click the plus icon to add each CUSIP.">
                            <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label>
                        <div style="display:flex">
                            <input @change="onCusipValueChange()" maxlength="9"  type="text" class="form-control" id="inputLast" placeholder="Cusip"  v-model.trim="cusipName" >
                            <a :class="{ shake: cusipValueChange }" @click="addCusip(cusipName)" style="padding: 8px;margin-left: 8px;margin-top: 1px;" class="ibtn grn">
                              <i class="fas fa-plus"></i>
                            </a>
                        </div>
                        <div>
                                <ul class="cusip mt-2">
                                    <li v-for="(cusip,indexID) in selelctedCusips" :key="indexID">
                                        {{ cusip }} <i  @click="deleteCusip(indexID)"  class="fas fa-trash" style="font-size: 12px;"></i>
                                    </li>
                                </ul>
                            </div>
                              
                    </div>
                  
                  </div>

                <!--OPTIONAL Fields-->
                <div class="w-100 mb-3">
                  <b-button
                    variant="link"
                    class="allStates accordion-button w-100 text-left"
                    v-b-toggle.accordion-cusipDetail
                  >
                    Additional filters

                  </b-button>

                  <b-collapse
                    id="accordion-cusipDetail"
                    accordion="my-accordion-parent"
                    role="tabpanel"
                    class="mt-5"
                  >
                  <div class="form-row col-md-12">
                    <div class="form-group col-md-6">
                      <label>Max Coupon %</label>
                      <input
                        type="number"
                        class="form-control"
                        placeholder="Max Coupon"
                        v-model="filterData.maxCoupon"
                      />
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputEmail4">Municipal Security Types
                         
                          <span class="hint" data-toggle="tooltip" data-placement="right"  title="Use Include to only show these bonds , or Exclude to hide them.">
                            <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                        </label> <a class="allStates" @click="clearMuncipalType()"><i class="fa fa-trash"></i> Clear</a>
                        <div class="flex-container mt-3">
                        <table class="table align-items-center table-flush table-hover bidtbl black-tbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class=" text-left"></th>
                              <th scope="col" class=" text-center">
                                <div class="form-check d-inline-flex align-items-center">
                                  <input class="form-check-input mr-2 mt-0" type="radio" v-model="isMunicipalSecurityTypesIn" value="EXCLUDE">
                                  EXCLUDE
                                 
                                  <span class="hint" data-toggle="tooltip" data-placement="right"  title="Exclude bonds with the selected Municipal Security Types type.">
                                    <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                                </div>
                              </th>
                              <th scope="col" class=" text-center">
                                <div class="form-check d-inline-flex align-items-center">
                                  <input class="form-check-input mr-2 mt-0" type="radio" v-model="isMunicipalSecurityTypesIn"  value="INCLUDE">
                                  INCLUDE 
                              
                                  <span class="hint" data-toggle="tooltip" data-placement="right"  title="Only show bonds with the selected Municipal Security Types type.">
                                    <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          </table>
                      </div>

                        <!-- <div class="radio-buttons mt-1">
                            <label class="mr-3">
                                <input type="radio" v-model="isMunicipalSecurityTypesIn" value="EXCLUDE">
                                EXCLUDE
                            </label>
                            <label>
                                <input type="radio" v-model="isMunicipalSecurityTypesIn" value="INCLUDE">
                                INCLUDE
                            </label>
                        </div> -->

                        <multiselect
                            v-if="isMunicipalSecurityTypesIn"
                            :disabled="!isMunicipalSecurityTypesIn"
                            v-model="filterData.municipalSecurityTypes"
                            placeholder="Select"
                            label="name"
                            track-by="value"
                            :options="municipalSecurityTypes"
                            :multiple="true"
                            :close-on-select="false" class="mt-2"
                          ></multiselect>
                    </div>
                    
                  </div>
                  <div class="form-row col-md-12">
                      <div class="form-group col-md-6 attributes">
                        <label for="inputEmail4">Attributes</label><a class="allStates mb-3 mr-0" @click="clearAllAttributes()"><i class="fa fa-trash"></i> Clear All</a>
                        <table class="table align-items-center table-flush table-hover bidtbl black-tbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class="text-left"></th>
                              <th scope="col" class="text-center text-white">EXCLUDE</th>
                              <th scope="col" class="text-center text-white">INCLUDE</th>
                            </tr>
                          </thead>
                          <tbody class="list no-cursor attr-table">
                            <tr>
                              <td>PreRefund
                                 
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude Pre-Fund bonds.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>

                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.preRefund" name="EXCLUDEPreRefund" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.preRefund" name="INCLUDEPreRefund" value="INCLUDE">
                                </div>
                              </td>
                             
                            </tr>
                            <tr>
                              <td>escrowed
                               
                                  <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude Escrowed Bonds.">
                                    <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
              
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.escrowed" name="EXCLUDEescrowed" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.escrowed" name="INCLUDEescrowed" value="INCLUDE">
                                </div>
                              </td>
                            </tr>

                           
                            <tr>
                              <td>Bank Qualified
                                
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude Bank Qualified bonds.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.bankQ" name="EXCLUDEbankQ" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.bankQ" name="INCLUDEbankQ" value="INCLUDE">
                                </div>
                              </td>
                             
                            </tr>
                            <tr>
                              <td>callable
                               
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude Callable bonds.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                     
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.callable" name="EXCLUDEcallable" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.callable" name="INCLUDEcallable" value="INCLUDE">
                                </div>
                              </td>
                           
                            </tr>
                            <tr>
                              <td>putable
                                
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude Putable bonds.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                         
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.putable" name="EXCLUDEputable" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.putable" name="INCLUDEputable" value="INCLUDE">
                                </div>
                              </td>
                            
                            </tr>
                           
                            <tr> 
                              <td>sinking Fund
                                
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude Sinking Fund bonds.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                              
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.sinkingFund" name="EXCLUDEsinkingFund" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.sinkingFund" name="INCLUDEsinkingFund" value="INCLUDE">
                                </div>
                              </td>
                            
                            </tr>
                           
                            <tr>
                              <td>zero Coupon
                              
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude Zero Coupon bonds.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                            
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.zeroCoupon" name="EXCLUDEzeroCoupon" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.zeroCoupon" name="INCLUDEzeroCoupon" value="INCLUDE">
                                </div>
                              </td>
                          
                            </tr>
                            <tr>
                              <td>below Minimum Denomination 
                                
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude bonds having quantity Below Minimum Denomination.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                             
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.belowMin" name="EXCLUDEbelowMin" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.belowMin" name="INCLUDEbelowMin" value="INCLUDE">
                                </div>
                              </td>
                             
                            </tr>
                            <tr>
                              <td>technical Default
                                
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude bonds with technical default.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.technicalDefault" name="EXCLUDEtechnicalDefault" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.technicalDefault" name="INCLUDEtechnicalDefault" value="INCLUDE">
                                </div>
                              </td>
                            
                            </tr>
                            <tr>
                              <td>Irregular Settlement
                                
                                <span class="hint" data-toggle="tooltip" data-placement="right"  title="Choose to include or exclude bonds with irregular settlement.">
                                  <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                              </td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.irregularSettlement" name="irregularSettlement" value="EXCLUDE">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.irregularSettlement" name="irregularSettlement" value="INCLUDE">
                                </div>
                              </td>
                             
                            </tr>
                            
                          </tbody>
                        </table>
                    </div>
                    <div class="form-group col-md-6">
                    <div class="d-flex justify-content-between align-items-center">
                    <label for="inputLast">Proceeds
                     <span class="hint" data-toggle="tooltip" data-placement="right"  title="Use Include to only show these bonds , or Exclude to hide them.">
                        <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                    </label>
                    <a class="allStates mr-0" @click="clearProceeds()"><i class="fa fa-trash"></i> Clear</a>
                    </div>
                      <div class="flex-container mt-3">
                        <table class="table align-items-center table-flush table-hover bidtbl black-tbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class=" text-left"></th>
                              <th scope="col" class=" text-center">
                                <div class="form-check d-inline-flex align-items-center">
                                  <input class="form-check-input mr-2 mt-0" type="radio" v-model="proceedsType" name="proceedsType" value="EXCLUDE">
                                  EXCLUDE
                                 
                                  <span class="hint" data-toggle="tooltip" data-placement="right"  title="Exclude bonds with the selected proceeds type.">
                                    <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                                </div>
                              </th>
                              <th scope="col" class=" text-center">
                                <div class="form-check d-inline-flex align-items-center">
                                  <input class="form-check-input mr-2 mt-0" type="radio" v-model="proceedsType" name="proceedsType" value="INCLUDE">
                                  INCLUDE 
                              
                                  <span class="hint" data-toggle="tooltip" data-placement="right"  title="Only show bonds with the selected proceeds type.">
                                    <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          </table>
                      </div>
                      <div class="form-group" >
                        <multiselect
                              v-if="proceedsType"
                        :disabled="!proceedsType"
                            v-model="proceedsValue"
                            placeholder="Select"
                            label="name"
                            track-by="value"
                            :options="purposeConstants"
                            :multiple="true"
                            :close-on-select="false"
                          ></multiselect>
                      </div>

                  </div>
                     <div class="form-group insurer col-md-6" v-if="filterData.insured === 'ONLY_IF' || filterData.insured === 'INCLUDE'">
                                <div class="d-flex justify-content-between align-items-center">
                                  <label for="inputLast">Insurers </label>
                                  <a class="allStates mr-0" @click="clearInsurers()"><i class="fa fa-trash"></i> Clear</a>
                                </div>
                                  <!-- <div class="flex-container mt-3">
                                    <table class="table align-items-center table-flush table-hover bidtbl black-tbl">
                                      <thead class="thead-light">
                                        <tr>
                                          <th scope="col" class=" text-left"></th>
                                          <th scope="col" class=" text-center">
                                            <div class="form-check">
                                              <input class="form-check-input" type="radio" v-model="insurersType" name="insurersType" value="EXCLUDE">
                                              EXCLUDE</div>
                                          </th>
                                          <th scope="col" class=" text-center">
                                            <div class="form-check">
                                              <input class="form-check-input" type="radio" v-model="insurersType" name="insurersType" value="INCLUDE">
                                              INCLUDE</div>
                                          </th>
                                        </tr>
                                      </thead>
                                      </table>
                                  </div> -->
                                  <div class="flex-container mt-3">
                        <table class="table align-items-center table-flush table-hover bidtbl black-tbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class=" text-left"></th>
                              <th scope="col" class=" text-center">
                                <div class="form-check d-inline-flex align-items-center">
                                  <input class="form-check-input mr-2 mt-0" type="radio" v-model="insurersType" name="insurersType" value="EXCLUDE">
                                  EXCLUDE
                                 
                                  <span class="hint" data-toggle="tooltip" data-placement="right"  title="Exclude bonds with the selected bond insurer.">
                                    <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                                </div>
                              </th>
                              <th scope="col" class=" text-center">
                                <div class="form-check d-inline-flex align-items-center">
                                  <input class="form-check-input mr-2 mt-0" type="radio" v-model="insurersType" name="insurersType" value="INCLUDE">
                                  INCLUDE 
                              
                                  <span class="hint" data-toggle="tooltip" data-placement="right"  title="Only show bonds with the selected bond insurer.">
                                    <i class="fa fa-info-circle info-i" style="color: #027fc5"></i> </span>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          </table>
                      </div>
                                  <div class="form-group" v-if="insurersType">
                                    <multiselect
                                        v-model="insurersValue"
                                        placeholder="Select"
                                        :options="bondinsurer"
                                        :multiple="true"
                                        :close-on-select="false"
                                      ></multiselect>
                                  </div>
                              </div> 

                  </div>
                  </b-collapse>
                </div>
                </div>

                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-outline-light"  @click="$emit('close')">Close</button>
                    <!-- <button v-if="filterData.id" :disabled="loading" type="button" class="btn btn-info" @click="showPreview()">PREVIEW</button> -->
                    <button v-if="!filterData.id" type="button" class="btn btn-primary" @click="addFilter()">ADD</button>
                  <button v-if="filterData.id" type="button" class="btn btn-primary" @click="updateFilter()">UPDATE</button>
                    
                </div>
               
            </form>
          </div>
        </div>
      </div>
      <FilterPreview :filterData="selectedfilter" v-if="filterModalIsOpen" @close="filterModalIsOpen = false" />
    </div>
  </template>
  <script>
import authService from "@/authService";
import config from "@/config";
import stateConstants from "@/stateConstants";
//import Datepicker from "vuejs-datepicker";
import moodyConstants from "@/moodyRatingConstants";
import spRatingConstants from "@/spRatingConstants";
import bondinsurer from "@/bondinsurerConstants";
import purposeConstants from "@/purposeConstants";
import FilterPreview from "@/components/offeringfeed/FilterPreview.vue";
export default {
  name: "sendBidModal",
  components: {
    //Datepicker,
    FilterPreview
  },
  props: ["selectedfilter"],
  data() {
    return {
      loading: false,
      filterData: {},
      errors: [],
      stateConstantsCopy: stateConstants,
      stateCodes : [],
      selelctedStates: [],
      cusipName: "",
      selelctedCusips: [],
      moodyConstants:moodyConstants,
      spRatingConstants:spRatingConstants,
      cusipValueChange : false,
      isStateSelectAll : true,
      ratingFrom : "",
      ratingTo : "",
      ratingFromUnder : "",
      ratingToUnder : "",
      municipalSecurityTypes : [
          { name: "Unknown", value: "UNKNOWN" },
          { name: "Special assessment", value: "SPECIAL_ASSESSMENT" },
          { name: "Double barreled", value: "DOUBLE_BARRELED" },
          { name: "Lease-rental", value: "LEASE_RENTAL" },
          { name: "Fuel/vehicle tax", value: "FUEL_VEHICLE_TAX" },
          { name: "Unlimited G.O.", value: "UNLIMITED_G_O_" },
          { name: "Limited G.O.", value: "LIMITED_G_O_" },
          { name: "Other", value: "OTHER" },
          { name: "Revenue", value: "REVENUE" },
          { name: "Sales/excise tax", value: "SALES_EXCISE_TAX" },
          { name: "Tax allocation/increment", value: "TAX_ALLOCATION_INCREMENT" },
          { name: "U.S. government-backed", value: "U_S_GOVERNMENT_BACKED" },
          { name: "Tobacco state appropriated", value: "TOBACCO_STATE_APPROPRIATED" },
          { name: "Tobacco settlement non-appropriated", value: "TOBACCO_SETTLEMENT_NON_APPROPRIATED" },
          { name: "Federal grant", value: "FEDERAL_GRANT" },
          { name: "Cigarette tax", value: "CIGARETTE_TAX" },
          { name: "Hotel tax", value: "HOTEL_TAX" },
          { name: "Miscellaneous tax", value: "MISCELLANEOUS_TAX" },
          { name: "Personal income tax", value: "PERSONAL_INCOME_TAX" },
          { name: "Pilot", value: "PILOT" }
        ],
        insurersType : "",
        proceedsType : "",
        insurersValue : [],
        proceedsValue : [],
        bondinsurer : [...new Set(bondinsurer.map(item => item.Abbreviation))],
        purposeConstants : purposeConstants,  
        isMunicipalSecurityTypesIn : "",
        customerList : [],
        filterModalIsOpen: false,
        isRep : false,
        isClient : false,
        isAdmin : false,
        clientList : [],
        selectedClient : null,
        // shouldEmailNotify : false,
        // shouldPushNotify : false
    };
  },
  methods: {
    onClientSelect(){
      if(this.selectedClient){
        this.filterData.userId = this.selectedClient.id;
      } 
    },
     getClients() {
      const auth = {
        headers: { "org-token": authService.getOrgToken() },
      };
      let url = "";
      if(this.isRep && !this.isAdmin){
        url = config.baseUrlAutoBidder + "/user/client-list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&clientRepId=" + authService.getUser().id;
      } else {
        url = config.baseUrlBidSide + "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Client";
      }
      this.$http
        .get(
          url,
          auth
        )
        .then((result) => {
          this.clientList = result.data.content.map((client) => {
            return {
              id: client.id,
              clientFullName: client.firstName + " " + client.lastName,
            };
          });

            if(this.selectedfilter && this.selectedfilter.userId){
              this.selectedClient = this.clientList.find(client => client.id === this.selectedfilter.userId);
              this.filterData.userId = this.selectedfilter.userId;
            }
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    showPreview(){
           var addData = {...this.filterData};
            addData.minMaturityDate = addData.minMaturityDate ? this.moment(addData.minMaturityDate).format("YYYY-MM-DD") : null;               
            addData.maxMaturityDate = addData.maxMaturityDate ? this.moment(addData.maxMaturityDate).format("YYYY-MM-DD") : null;
            addData.minCallDate = addData.minCallDate ? this.moment(addData.minCallDate).format("YYYY-MM-DD") : null;               
            addData.maxCallDate = addData.maxCallDate ? this.moment(addData.maxCallDate).format("YYYY-MM-DD") : null; 
            // addData.userId = authService.getUser().id;
            addData.cusips = this.selelctedCusips ? this.selelctedCusips : [];
            // addData.ratingMoody = addData.ratingMoody ? addData.ratingMoody : [];
            addData.states =  this.stateCodes.filter(user => user.isActive === true).map(state => state.short)
            if(this.ratingFrom && !this.ratingTo){
              this.ratingTo = this.spRatingConstants[this.spRatingConstants.length - 1];
            }
            if(this.ratingTo && !this.ratingFrom){
              this.ratingFrom = this.spRatingConstants[0];
            }
            if(this.ratingFromUnder && !this.ratingToUnder){
              this.ratingToUnder = this.spRatingConstants[this.spRatingConstants.length - 1];
            }
            if(this.ratingToUnder && !this.ratingFromUnder){
              this.ratingFromUnder = this.spRatingConstants[0];
            }
            addData.ratingSP = this.getRangeOfRatings(this.ratingFrom,this.ratingTo)
            addData.ratingUnderlying = this.getRangeOfRatings(this.ratingFromUnder,this.ratingToUnder);

            addData.municipalSecurityTypes = addData.municipalSecurityTypes ? addData.municipalSecurityTypes.map((e) => e.value) : []

            addData.isInsurersIn = this.insurersType === "INCLUDE" ? true : (this.insurersType === "EXCLUDE" ? false : null);
            // addData.insurers = this.insurersValue ?  this.insurersValue : [];
            addData.insurers = this.insurersValue ?  this.insurersValue.map(item => item === "FIREMEN'S INS OF NEWARK/CONTL CAS INS" ? "FIREMEN_S_INS_OF_NEWARK/CONTL_CAS_INS" : item) : [];

            addData.isProceedsIn = this.proceedsType === "INCLUDE" ? true : (this.proceedsType === "EXCLUDE" ? false : null);
            addData.proceeds = this.proceedsValue ? this.proceedsValue.map((e) => e.value) : [];
            addData.isMunicipalSecurityTypesIn = this.isMunicipalSecurityTypesIn === "INCLUDE" ? true : (this.isMunicipalSecurityTypesIn === "EXCLUDE" ? false : null);
            addData.customers = this.filterData.customers ? this.filterData.customers.map(customer => customer.id) : [];

            if(addData.insured == 'EXCLUDE'){
              addData.isInsurersIn = null;
              addData.insurers = [];
            }

            delete addData.createdAt
            delete addData.enable
            delete addData.userId
            delete addData.description;
            delete addData.status;
            delete addData.filterType;
            delete addData.shouldEmailNotify;
            delete addData.shouldPushNotify;

        
        let data = {
            "size": 10,
            "cursor":  null,
            "userId": authService.getUser().id,
            "cognitoSub": authService.getUser().cognitoSub,
            "uuid": this.uuidv4(),
            "sortColumn": null,
            "sortOrder": null,
            "filter": addData
        };
      
      this.$emit("previewFilter" , data);
      localStorage.setItem("previewFilter", JSON.stringify(addData));

    },
    clearInsurers(){
      this.insurersType = "";
      this.insurersValue = [];
    },
    clearProceeds(){
      this.proceedsType = "";
      this.proceedsValue = [];
    },
    clearMuncipalType(){
      this.isMunicipalSecurityTypesIn = "";
      this.filterData.municipalSecurityTypes = [];
    },
    clearAllAttributes() {
      const filters = [
        'preRefund',
        'escrowed',
        'insured',
        'taxable',
        'amt',
        'bankQ',
        'callable',
        'putable',
        'sinkingFund',
        'zeroCoupon',
        'belowMin',
        'greenBonds',
        'technicalDefault',
        'irregularSettlement'
      ];
      for (const filter of filters) {
        this.filterData[filter] = null;
      }
    },
    checkRatingRangeisValid(){
      var stringArry = [...this.spRatingConstants].reverse();
      if(this.ratingFrom && this.ratingTo){
          var startIndex = stringArry.indexOf(this.ratingFrom);
          var endIndex = stringArry.indexOf(this.ratingTo);
          if(startIndex <= endIndex) {
            console.log('Selected range is valid');
          } else {
            this.$alert('From Rating should be lower than to rating',"","error");
            this.ratingFrom = "";
            this.ratingTo = "";
          }
      }

    },
    checkRatingRangeisValidUnder(){
      var stringArry = [...this.spRatingConstants].reverse();
      if(this.ratingFromUnder && this.ratingToUnder){
          var startIndex = stringArry.indexOf(this.ratingFromUnder);
          var endIndex = stringArry.indexOf(this.ratingToUnder);
          if(startIndex <= endIndex) {
            console.log('Selected range is valid');
          } else {
            this.$alert('From Rating should be lower than to rating',"","error");
            this.ratingFromUnder = "";
            this.ratingToUnder = "";
          }
      }

    },
    getRangeOfRatings(datafrom,datato){
      console.log(datafrom,datato)
      var stringArry = [...this.spRatingConstants].reverse();
      var startIndex = stringArry.indexOf(datafrom);
      var endIndex = stringArry.indexOf(datato);
      var range = [];
      if(startIndex > endIndex){
        // swap the values
        var temp = startIndex;
        startIndex = endIndex;
        endIndex = temp;
      }
      if(datafrom && datato){
        range = stringArry.slice(startIndex, endIndex + 1);
      }else{
        range = []
      }
      return range;
    },
    selectAllState(){
      if(this.isStateSelectAll){
        this.stateCodes.map(state => state.isActive = true)
        this.isStateSelectAll = false
      }else{
        this.stateCodes.map(state => state.isActive = false)
        this.isStateSelectAll = true
      }
    },
    selectState(state){
      state.isActive = !state.isActive
    },
    onCusipValueChange(){
      this.cusipValueChange = true;
    },
    deleteCusip(removeIndex){
      const updatedCusips = [...this.selelctedCusips];
            updatedCusips.splice(removeIndex, 1);
            this.selelctedCusips = updatedCusips;
          
    },
    addCusip(cusip){
        if(cusip.length != 9){
            this.$alert("Enter 9 digit characters long  CUSIP");
            return
        }
        if(cusip){
            this.selelctedCusips.push(cusip);
            this.cusipName = "";
        }
        this.cusipValueChange = false;

    },
    addFilter() {
      let isValid = this.checkForm();
      if (isValid) {
        this.loading = true;
        var addData = this.filterData;
            addData.minMaturityDate = addData.minMaturityDate ? this.moment(addData.minMaturityDate).format("YYYY-MM-DD") : null;               
            addData.maxMaturityDate = addData.maxMaturityDate ? this.moment(addData.maxMaturityDate).format("YYYY-MM-DD") : null;               
            addData.minCallDate = addData.minCallDate ? this.moment(addData.minCallDate).format("YYYY-MM-DD") : null;               
            addData.maxCallDate = addData.maxCallDate ? this.moment(addData.maxCallDate).format("YYYY-MM-DD") : null;               
            addData.status = "ACTIVE";
            addData.cusips = this.selelctedCusips ? this.selelctedCusips : [];
            // addData.ratingMoody = addData.ratingMoody ? addData.ratingMoody : [];
            addData.states =  this.stateCodes.filter(user => user.isActive === true).map(state => state.short)
            addData.createdBy = authService.getUser().id;
            if(!this.isClient){
              addData.isForClient = true;
              addData.userId = this.filterData.userId ? this.filterData.userId : null;
            }else{
              addData.isForClient = true;
              addData.userId = authService.getUser().id;
            }
            
            if(this.ratingFrom && !this.ratingTo){
              this.ratingTo = this.spRatingConstants[this.spRatingConstants.length - 1];
            }
            if(this.ratingTo && !this.ratingFrom){
              this.ratingFrom = this.spRatingConstants[0];
            }
            if(this.ratingFromUnder && !this.ratingToUnder){
              this.ratingToUnder = this.spRatingConstants[this.spRatingConstants.length - 1];
            }
            if(this.ratingToUnder && !this.ratingFromUnder){
              this.ratingFromUnder = this.spRatingConstants[0];
            }
            addData.ratingSP = this.getRangeOfRatings(this.ratingFrom,this.ratingTo);
            addData.ratingUnderlying = this.getRangeOfRatings(this.ratingFromUnder,this.ratingToUnder);
            addData.municipalSecurityTypes = addData.municipalSecurityTypes ? addData.municipalSecurityTypes.map((e) => e.value) : []

            addData.isInsurersIn = this.insurersType === "INCLUDE" ? true : (this.insurersType === "EXCLUDE" ? false : null);
            // addData.insurers = this.insurersValue ?  this.insurersValue : [];
            addData.insurers = this.insurersValue ?  this.insurersValue.map(item => item === "FIREMEN'S INS OF NEWARK/CONTL CAS INS" ? "FIREMEN_S_INS_OF_NEWARK/CONTL_CAS_INS" : item) : [];

            addData.isProceedsIn = this.proceedsType === "INCLUDE" ? true : (this.proceedsType === "EXCLUDE" ? false : null);
            addData.proceeds = this.proceedsValue ? this.proceedsValue.map((e) => e.value) : [];

            addData.isMunicipalSecurityTypesIn = this.isMunicipalSecurityTypesIn === "INCLUDE" ? true : (this.isMunicipalSecurityTypesIn === "EXCLUDE" ? false : null);
            addData.customers = this.filterData.customers ? this.filterData.customers.map(customer => customer.id) : [];
            
            if(addData.insured == 'EXCLUDE'){
              addData.isInsurersIn = null;
              addData.insurers = [];
            }

            addData.minQuantity = Number(addData.minQuantity) / 1000;

            delete addData.enable
            delete addData.isDuplicate
            delete addData.clientFirstName
            delete addData.clientLastName
            delete addData.clientLastName
            
           

    
        const auth = {
          headers: { "org-token": authService.getOrgToken() },
        };
        this.$http
          .post(config.baseUrlAutoBidder + "/offering-feed/filter", addData, auth)
          .then(() => {
            this.loading = false;
            this.$alert("Successfully added", "", "success");
            this.$emit("close");
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    updateFilter() {
      let isValid = this.checkForm();
      if (isValid) {
        this.loading = true;
        var addData = {...this.filterData};
            addData.minMaturityDate = addData.minMaturityDate ? this.moment(addData.minMaturityDate).format("YYYY-MM-DD") : null;               
            addData.maxMaturityDate = addData.maxMaturityDate ? this.moment(addData.maxMaturityDate).format("YYYY-MM-DD") : null;
            addData.minCallDate = addData.minCallDate ? this.moment(addData.minCallDate).format("YYYY-MM-DD") : null;               
            addData.maxCallDate = addData.maxCallDate ? this.moment(addData.maxCallDate).format("YYYY-MM-DD") : null; 
            // addData.userId = authService.getUser().id;
            addData.cusips = this.selelctedCusips ? this.selelctedCusips : [];
            // addData.ratingMoody = addData.ratingMoody ? addData.ratingMoody : [];
            addData.states =  this.stateCodes.filter(user => user.isActive === true).map(state => state.short)
            if(this.ratingFrom && !this.ratingTo){
              this.ratingTo = this.spRatingConstants[this.spRatingConstants.length - 1];
            }
            if(this.ratingTo && !this.ratingFrom){
              this.ratingFrom = this.spRatingConstants[0];
            }
            if(this.ratingFromUnder && !this.ratingToUnder){
              this.ratingToUnder = this.spRatingConstants[this.spRatingConstants.length - 1];
            }
            if(this.ratingToUnder && !this.ratingFromUnder){
              this.ratingFromUnder = this.spRatingConstants[0];
            }
            addData.ratingSP = this.getRangeOfRatings(this.ratingFrom,this.ratingTo)
            addData.ratingUnderlying = this.getRangeOfRatings(this.ratingFromUnder,this.ratingToUnder);

            addData.municipalSecurityTypes = addData.municipalSecurityTypes ? addData.municipalSecurityTypes.map((e) => e.value) : []

            addData.isInsurersIn = this.insurersType === "INCLUDE" ? true : (this.insurersType === "EXCLUDE" ? false : null);
            // addData.insurers = this.insurersValue ?  this.insurersValue : [];
            addData.insurers = this.insurersValue ?  this.insurersValue.map(item => item === "FIREMEN'S INS OF NEWARK/CONTL CAS INS" ? "FIREMEN_S_INS_OF_NEWARK/CONTL_CAS_INS" : item) : [];

            addData.isProceedsIn = this.proceedsType === "INCLUDE" ? true : (this.proceedsType === "EXCLUDE" ? false : null);
            addData.proceeds = this.proceedsValue ? this.proceedsValue.map((e) => e.value) : [];
            addData.isMunicipalSecurityTypesIn = this.isMunicipalSecurityTypesIn === "INCLUDE" ? true : (this.isMunicipalSecurityTypesIn === "EXCLUDE" ? false : null);
            addData.customers = this.filterData.customers ? this.filterData.customers.map(customer => customer.id) : [];

            if(addData.insured == 'EXCLUDE'){
              addData.isInsurersIn = null;
              addData.insurers = [];
            }

            addData.minQuantity = Number(addData.minQuantity) / 1000;

            delete addData.createdAt
            delete addData.enable
            // delete addData.userId
            delete addData.clientFirstName;
            delete addData.clientLastName;
            delete addData.clientLastName;
            delete addData.totalHitCount;
            delete addData.todayHitCount;



        const auth = {
          headers: { "org-token": authService.getOrgToken() },
        };
        this.$http
          .put(config.baseUrlAutoBidder + "/offering-feed/filter", addData, auth)
          .then(() => {
            this.loading = false;
            this.$alert("Successfully updated", "", "success");
            this.$emit("close",this.filterData.id);
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    checkForm() {
      this.errors = [];
      if (!this.filterData.name) {
        this.errors.push("Name is required.");
        return false;
      }
      if (!this.filterData.offeringTypeId) {
        this.errors.push("Product is required.");
        return false;
      }
       if(!this.filterData.minPrice){
        this.errors.push("Min offering price is required.");
        return false;
      }
      if(!this.filterData.maxPrice){
        this.errors.push("Max offering price is required.");
        return false;
      }
      if(!this.filterData.minYear){
        this.errors.push("Min Maturity Year is required.");
        return false;
      }
      if(!this.filterData.maxYear){
        this.errors.push("Max Maturity Year is required.");
        return false;
      }

      if (!this.filterData.minCoupon) {
        this.errors.push("Min Coupon is required.");
        return false;
      }
      if (!this.ratingFrom) {
        this.errors.push("Please select minimum rating.");
        return false;
      }
      //rating validation
      if (!this.ratingTo) {
        this.errors.push("Please select maximum rating.");
        return false;
      }
    


      if (!this.isClient && !this.filterData.userId) {
        this.errors.push("Client is required.");
        return false;
      }
      return true;
    },
    setFileds(){
      if (this.selectedfilter){
        this.filterData = this.selectedfilter;
        let dataFromLocalStorage = localStorage.getItem("previewFilter");
        if(dataFromLocalStorage){
          let parsedData = JSON.parse(dataFromLocalStorage);
          if(parsedData.id === this.selectedfilter.id){
            this.selectedfilter = parsedData;
            this.filterData = this.selectedfilter;
          }
        }
   
        this.selelctedCusips = this.selectedfilter.cusips ? this.selectedfilter.cusips : [];
        if(this.selectedfilter.states){
          this.selectedfilter.states.map(code =>{
              this.stateCodes.map(stateObj => {
                  if(stateObj.short == code) stateObj.isActive = true
              })
          });
        }
        if(this.selectedfilter.ratingSP && this.selectedfilter.ratingSP.length > 0){
          this.ratingFrom = this.selectedfilter.ratingSP[0];
          this.ratingTo =  this.selectedfilter.ratingSP[this.selectedfilter.ratingSP.length - 1];
        }else{
          this.ratingFrom = "";
          this.ratingTo = "";
        }
        if( this.selectedfilter.ratingUnderlying && this.selectedfilter.ratingUnderlying.length > 0){
          this.ratingFromUnder = this.selectedfilter.ratingUnderlying[0];
          this.ratingToUnder =  this.selectedfilter.ratingUnderlying[this.selectedfilter.ratingUnderlying.length - 1];
        }
        else{
         
          this.ratingFromUnder = "";
          this.ratingToUnder = "";
        }
        if(this.selectedfilter.municipalSecurityTypes){
          let selectedTypes = [];
          this.selectedfilter.municipalSecurityTypes.map(type =>{
            this.municipalSecurityTypes.map(munType =>{
              if(munType.value == type){
                selectedTypes.push(munType)
              }
            })
          })
          this.selectedfilter.municipalSecurityTypes = selectedTypes

        }

         // this.insurersType =  this.selectedfilter.isInsurersIn ? "INCLUDE" : "EXCLUDE";
         if (this.selectedfilter.isInsurersIn === true) {
          this.insurersType = "INCLUDE";
        } else if (this.selectedfilter.isInsurersIn === false) {
          this.insurersType = "EXCLUDE";
        } else {
          this.insurersType = "";
        }
        // this.insurersValue = this.selectedfilter.insurers;
        this.insurersValue = this.selectedfilter.insurers ?  this.selectedfilter.insurers.map(item => item === "FIREMEN_S_INS_OF_NEWARK/CONTL_CAS_INS" ? "FIREMEN'S INS OF NEWARK/CONTL CAS INS" : item) : [];
        // this.proceedsType =  this.selectedfilter.isProceedsIn ? "INCLUDE" : "EXCLUDE";
        if (this.selectedfilter.isProceedsIn === true) {
          this.proceedsType = "INCLUDE";
        } else if (this.selectedfilter.isProceedsIn === false) {
          this.proceedsType = "EXCLUDE";
        } else {
          this.proceedsType = "";
        }
        if(this.selectedfilter.proceeds){
          let selectedPurposeTypes = [];
          this.selectedfilter.proceeds.map(type =>{
            this.purposeConstants.map(purposeType =>{
              if(purposeType.value == type){
                selectedPurposeTypes.push(purposeType)
              }
            })
          })
          this.proceedsValue = selectedPurposeTypes

        }
        if(!this.insurersValue){
          this.insurersType = ""
        }
        if(!this.proceedsValue){
          this.proceedsType = ""
        }
        if (this.selectedfilter.isMunicipalSecurityTypesIn === true) {
            this.isMunicipalSecurityTypesIn = "INCLUDE";
        }else if (this.selectedfilter.isMunicipalSecurityTypesIn === false) {
            this.isMunicipalSecurityTypesIn = "EXCLUDE";
        } 

        this.filterData.minQuantity = this.selectedfilter.minQuantity ? this.selectedfilter.minQuantity * 1000 : "";

    
    }else{
        this.selelctedCusips = [];
    } 
    },
    filterTypeChange(){
      if(!this.filterData.id && !this.filterData.isDuplicate){
        if(this.filterData.filterType == "SEARCH"){
          this.getActiveFilter()
        }else{
          this.resetToDefault();
        }
      }
    },
    resetToDefault(){
      this.selelctedCusips = [];
      this.stateCodes.map(state => state.isActive = false);
      this.ratingFrom = "";
      this.ratingTo = "";
      this.filterData.name = ""
      this.filterData.offeringTypeId =""
      this.filterData.minQuantity = ""
      this.filterData.description = ""
      this.filterData.maxQuantity = ""
      this.filterData.minYear = ""
      this.filterData.maxYear = ""
      this.filterData.minCoupon = ""
      this.filterData.maxCoupon = ""
      this.filterData.minYtw = ""
      this.filterData.maxYtw = ""
      this.filterData.minYtm = ""
      this.filterData.maxYtm = ""
      this.filterData.minMaturityDate = ""
      this.filterData.maxMaturityDate = ""
      this.filterData.minCallDate = ""
      this.filterData.maxCallDate = ""
      this.filterData.minCallYear = ""
      this.filterData.maxCallYear = ""
      this.filterData.municipalSecurityTypes = [];
      this.filterData.preRefund = "INCLUDE";
      this.filterData.escrowed = "INCLUDE";
      this.filterData.insured = "INCLUDE";
      this.filterData.taxable = "INCLUDE";
      this.filterData.amt = "INCLUDE";
      this.filterData.bankQ = "INCLUDE";
      this.filterData.callable = "INCLUDE";
      this.filterData.putable = "INCLUDE";
      this.filterData.sinkingFund = "INCLUDE";
      this.filterData.zeroCoupon = "INCLUDE";
      this.filterData.belowMin = "INCLUDE";
      this.filterData.greenBonds = "INCLUDE";
      this.filterData.technicalDefault = "INCLUDE";
      this.filterData.irregularSettlement = "INCLUDE";
      this.filterData.customers = [];
      
    },
    getCustomerList(){
            // this.loading = true;
            const auth = {
              headers: { 'org-token': authService.getOrgToken() }
            };
            
            this.$http
              .get(
                config.baseUrlAutoBidder +
                `/customer/name-list`,
                auth
              )
              .then(response => {
                this.customerList = response.data.map((data) => {
                    // Combine the name parts with spaces in between
                    data.customerFullName = `${data.customerFirstName || ''} ${data.customerMiddleName || ''} ${data.customerLastName || ''}`.trim();
                    return data;
                  });
                  if (this.selectedfilter){
                    if (this.selectedfilter.customers.length) {
                      let customersSaved = [];
                      this.selectedfilter.customers.forEach((data) => {
                        this.customerList.forEach((customer) => {
                          if (customer.id === data) {
                            console.log("data",customer)
                            customersSaved.push(customer);
                          }
                        });
                      });
                      this.filterData.customers = customersSaved;
                    }
                  }
                //this.filterData.customers =   
              // this.loading = false;

                //customerFullName
              })
    },
    getFilterDetailsById(){
      //offering-feed/filter
      const auth = {
            headers: { "org-token": authService.getOrgToken() },
          };
          this.$http
            .get(config.baseUrlAutoBidder + "/offering-feed/filter?id=" + this.selectedfilter.id, auth)
            .then((result) => {
              if( this.selectedfilter.isDuplicate){
                  result.data.name = result.data.name + " duplicate";
                  delete result.data.id;
                  result.data.isDuplicate = true;

              }
              this.selectedfilter = result.data;
              
              this.setFileds();
            })
            .catch(() => {
              this.loading = false;
            });
    }

  },
  mounted() {

    this.getCustomerList();
    this.filterData.filterType = "FILTER";
    this.filterData.offeringTypeId = '1'
    // this.stateCodes = this.stateConstantsCopy.map(state =>  {state.short});
    this.stateCodes = this.stateConstantsCopy.map(state => ({
                        short: state.short,
                        isActive: false
                      }));

     this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Rep')   ? this.isRep  = true : this.isRep  = false;
          roleArray.includes('Client')   ? this.isClient  = true : this.isClient  = false;
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          this.getClients();
          
        }
      });
      if(this.selectedfilter && this.selectedfilter.id || this.selectedfilter.isDuplicate){
        this.getFilterDetailsById();
      }
    
  },
};
</script>
<style scoped>
.modal i {
    margin-right: 2px;
}
 .shake {
      animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
      transform: translate3d(0, 0, 0);
    }

    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }
   .flex-container{
    display: flex;
    flex-wrap: wrap;
   }
   .flex-container div {
    padding: 5px;
   }
   .flex-container div.active{
    background-color: #006fae;
    color: white;
   }
   .attr-table td{
    text-transform: uppercase;
    padding: 3px;
   }

   .accordion-button::after {
    content: "\21E9";
    color: #ffffff;
    font-weight: 700;
    float: right;
    margin-left: 5px;
  }
  .accordion-button.not-collapsed::after {
    content: "\21E7";
  }
  .multiselect__tag-icon::after {
    font-size: 20px !important;
  }

  .info-i{
    margin-left: 5px;
    cursor: pointer;
    font-size: 13px !important;
  }
   
   .black i {
    border : none !important;
    background : none !important;
   }
  
</style>